var React = require('react');

function Eye2 (props) {
    return React.createElement("svg",props,[React.createElement("line",{"fill":"#FFFFFF","x1":"-329.6","y1":"-30.1","x2":"540.4","y2":"-30.1","key":0}),React.createElement("line",{"fill":"none","x1":"-329.5","y1":"-30","x2":"540.4","y2":"-30","key":1}),React.createElement("path",{"d":"M0,139.1V70.9C0,31.8,32.2,0,71.7,0h66.6C177.8,0,210,31.8,210,70.9V210l-138.3,0C32.2,210,0,178.2,0,139.1L0,139.1z\n\t M31.5,139.1c0,21.7,18,39.4,40.2,39.4l106.8,0V70.9c0-21.7-18-39.4-40.2-39.4H71.7c-22.2,0-40.2,17.7-40.2,39.4V139.1z M31.5,139.1\n\t","key":2})]);
}

Eye2.defaultProps = {"version":"1.2","baseProfile":"tiny","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 210 210","xmlSpace":"preserve"};

module.exports = Eye2;

Eye2.default = Eye2;
